import React, { useEffect, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../assets/svg/Svg";
import { NotePencil, Trash } from "@phosphor-icons/react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as contactUsSlice from "../../../../redux/slices/contactUsSlice"; // Import the cartSlice
import moment from "moment";
import DeleteModal from "../../components/DeleteModal";


const ContactUs = () => {
  const [data, setData] = useState([]);
  const [deletableId, setDeletableId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [viewModal, setViewModal] = useState(false);
  const [selectedCart, setSelectedCart] = useState(null);
  const [paymentFilter,setPaymentFilter]=useState()
  const [finalData,setFinalData]=useState([])
  const { loading, contactUsList  } = useSelector((state) => state.contactUsSlice); // Updated to cartSlice

  

 
  // Update data when cartList changes
  useEffect(() => {
    if (contactUsList && contactUsList.length > 0) {
      const sortedData = [...contactUsList].sort((a, b) => 
        new Date(b.created_at) - new Date(a.created_at)
      );
      setData(sortedData);
    } else {
      setData([]);
    }
  }, [contactUsList]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => moment(row.created_at).format('DD/MM/YYYY HH:mm'), 
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row?.first_name, 
      sortable: true,
    },  {
      name: "Email",
      selector: (row) => row?.email, 
      sortable: true,
    }, {
      name: "Mobile Number",
      selector: (row) => row?.mobile_no, 
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row?.status === 1 ? "Pending" : "Approved"),
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex table_action">
          {/* <div className="edit" onClick={() => navigate(`/cart/edit/${row.id}`)}>
            <NotePencil size={18} />
          </div>
          <div className="delete">
            <Trash onClick={() => {
              setDeleteModal(true);
              setDeletableId(row.id);
            }} size={19} />
          </div> */}
          {/* <div className="view_more">
            <ViewMoreBtn redirectUrl={`/cart/details/${row.id}`} />
          </div> */}
          <div
            className="view_more"
            onClick={() => navigate(`/contact-us/${row?.id}`)}
          >
            <ViewMoreBtn />
          </div>
        </div>
      ),
    },
  ];

  const handleDeleteUser = () => {
    // Implement delete logic here
    // dispatch(cartSlice.deleteCartItem(deletableId, setDeletableId, setDeleteModal));
  };

  const filteredData = data?.filter(
    (item) =>
      item?.first_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.id?.toString() === searchText // Ensure id is compared as string
  );

  const handleSearch = (value) => {
    setSearchText(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "All",
  };

  const paginationPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * paginationPerPage,
    currentPage * paginationPerPage
  );

  const customPagination = () => {
    const page = Math.ceil(filteredData.length / paginationPerPage);
    const pageButtons = [];
    const startPage = Math.max(currentPage - 1, 1);
    const endPage = Math.min(currentPage + 1, page);

    // Always add the first page
    pageButtons.push(
      <button
        key={1}
        className={`btn-pagination ${currentPage === 1 ? "active" : ""}`}
        onClick={() => setCurrentPage(1)}
      >
        1
      </button>
    );

    // Ellipsis after the first page if necessary
    if (startPage > 2) {
      pageButtons.push(
        <span key="ellipsis-start" className="pagination-ellipsis">
          &hellip;
        </span>
      );
    }

    // Range of buttons around the current page
    for (let i = startPage; i <= endPage; i++) {
      if (i !== 1 && i !== page) {
        pageButtons.push(
          <button
            key={i}
            className={`btn-pagination ${currentPage === i ? "active" : ""}`}
            onClick={() => setCurrentPage(i)}
          >
            {i}
          </button>
        );
      }
    }

    // Ellipsis before the last page if necessary
    if (endPage < page - 1) {
      pageButtons.push(
        <span key="ellipsis-end" className="pagination-ellipsis">
          &hellip;
        </span>
      );
    }

    // Always add the last page
    if (page !== 1) {
      pageButtons.push(
        <button
          key={page}
          className={`btn-pagination ${currentPage === page ? "active" : ""}`}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </button>
      );
    }

    return (
      <div className="pagination-container mt-5">
        <button
          className="btn-pagination btn-pagi_prev"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {arrowRight}
        </button>
        <span>{pageButtons}</span>
        <button
          className="btn-pagination btn-pagi_next"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === page}
        >
          {arrowRight}
        </button>
      </div>
    );
  };


  useEffect(() => {
      dispatch(contactUsSlice.getContactUsData());
  }, []);

  return (
    <>
      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">Contact Us</h3>
            </div>
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <DataTable
                      title={<h6 className="card-title"></h6>}
                      columns={columns}
                      data={paymentFilter?paginatedData?.filter(d=>d?.status==paymentFilter):paginatedData}
                      pagination
                      paginationServer
                      paginationTotalRows={filteredData.length}
                      defaultSortFieldId="created_at"
                      defaultSortAsc={false}
                      onChangePage={(page) => setCurrentPage(page)}
                      paginationComponentOptions={paginationOptions}
                      paginationComponent={customPagination}
                      highlightOnHover
                      pointerOnHover
                      subHeader
                      subHeaderAlign="left"
                      subHeaderComponent={
                        <Row className="mb-3">
                          <Col md={6}>
                            <label htmlFor="search-trip-name">
                              Search by Name
                            </label>
                            <input
                              type="text"
                              id="search-trip-name"
                              className="form-control"
                              placeholder="Search by name"
                              value={searchText}
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </Col>
                          <Col md={6}>
                            <label htmlFor="payment-status">
                              Status
                            </label>
                            <select
                              id="payment-status"
                              className="form-control"
                              value={paymentFilter} 
                              onChange={(e)=>setPaymentFilter(e.target.value)} 
                            >
                              <option value="">Filter By Status</option>
                              <option value="1">Pending</option>
                              <option value="2">Approved</option>
                            </select>
                          </Col>
                        </Row>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            handleDelete={handleDeleteUser}
            name={"Cart Item"}
          />
          {/* <CartDetails
            viewModal={viewModal}
            setViewModal={setViewModal}
            selectedCart={selectedCart}
          />  */}
        </>
      )}
    </>
  );
};

export default ContactUs;
